import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PublicProfileState } from './public-profile.reducer';

export const selectPublicProfile = createFeatureSelector<PublicProfileState>('publicProfile');

export const selectPublicProfileLoading = createSelector(selectPublicProfile, ({ loading }) => loading);
